import { ReactComponent as Logo } from "assets/images/enforcer.svg";
import PrimaryBackButton from "components/BackButton/Primary";
import ContentContainer from "components/ContentContainer";
import LogoContainer from "components/LogoContainer";
import MaxWidthContainer from "components/MaxWidthContainer";
import SquareHighlightText from "components/SquareHighlightText";
import VideoOverlay from "components/VideoOverlay";
import { usePublicPagePopupsContext } from "iparque-components";
import React, { Suspense, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { videoIds } from "./configs";
import Message from "./Message";
import {
  StyledPopupsFullPageContainer,
  StyledHeading,
  StyledText,
  TextContainer,
  VideoButton,
} from "./styles";

const CityAnimation = React.lazy(() => import("./CityAnimation"));

const Head: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [videoVisible, setVideoVisible] = useState(false);
  const { paddingTop, animationDuration } = usePublicPagePopupsContext();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const showVideo = () => setVideoVisible(true);

  const closeVideo = () => setVideoVisible(false);

  return (
    <StyledPopupsFullPageContainer
      extraPaddingTop={paddingTop}
      extraPaddingTopAnimationDuration={animationDuration}
    >
      <header>
        <MaxWidthContainer>
          <LogoContainer>
            <nav aria-label="Navegação">
              <PrimaryBackButton color={theme.colors.enforcer} to="/" />
            </nav>
            <Logo
              id="logo"
              role="img"
              aria-labelledby={
                t("10714") /* Logo da app para fiscais de estacionamento */
              }
              title={
                t("10714") /* Logo da app para fiscais de estacionamento */
              }
            />
          </LogoContainer>
        </MaxWidthContainer>
      </header>
      <Suspense fallback={null}>
        <CityAnimation />
      </Suspense>
      <ContentContainer>
        <TextContainer id="text">
          <StyledHeading elementType="h1" color="secondary">
            {t("10163") /* Gestão eficaz de uma cidade inteligente! */}
          </StyledHeading>
          <StyledText>
            <p>
              {
                t(
                  "10164"
                ) /* O iParque Enforcer é a aplicação móvel para os fiscais de estacionamento de superfície, através do */
              }{" "}
              <u>iParque OnStreet</u>.{" "}
              {
                t(
                  "10166"
                ) /* Permite a emissão de contraordenações ou avisos de liquidação, leitura de matrículas, deteção automática de residentes e automóveis transgressores e a troca de mensagem com a concessionária. */
              }
            </p>
            <p>
              {
                t(
                  "10165"
                ) /* Tenha a fiscalização automóvel na palma da sua mão! */
              }
            </p>
          </StyledText>
          <SquareHighlightText
            color={theme.colors.enforcer}
            text={
              t(
                "10167"
              ) /* Faça login com a sua conta de concessionária e descarregue a app iParque Enforcer. */
            }
          />
          <VideoButton
            onClick={showVideo}
            color="danger"
            className="uppercase"
            title={
              t(
                "10715"
              ) /* A app de fiscalização de estacionamento em concessionária */
            }
          >
            {t("10132") /* Ver vídeo */}
          </VideoButton>
        </TextContainer>
      </ContentContainer>
      <Message />
      <VideoOverlay
        videoIds={videoIds}
        visible={videoVisible}
        onClose={closeVideo}
      />
    </StyledPopupsFullPageContainer>
  );
};

export default Head;
